import React from "react";
import SharedSetNewPasswordContent from "../components/set_new_password_content";

export default function SetNewPasswordContent({ actionKey }: { actionKey: string }) {
  return (
    <SharedSetNewPasswordContent
      actionKey={actionKey}
      title="Reset Your Password"
      setPasswordEndpointUrl="/password_reset/set_password"
      onSetPasswordSuccessRedirectUrl="/new_password_set"
    />
  );
}
